"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ImageHero", {
  enumerable: true,
  get: function get() {
    return _imageHero.ImageHero;
  }
});
Object.defineProperty(exports, "ImageHero2", {
  enumerable: true,
  get: function get() {
    return _imageHero2.ImageHero2;
  }
});
var _imageHero = require("./image-hero");
var _imageHero2 = require("./image-hero-2");